module.exports = __webpack_public_path__ + "img/design.cca69321.png";